import React from 'react';
import { useParams } from 'react-router-dom';
import Onboarding from './onboarding/Onboarding';

// /brands/:id/onboarding — the internal brand detail page's Onboarding tab:
// the client's install snippets and install check, for staff helping with
// an install.
export default function BrandDetailOnboardingTab() {
  const { id } = useParams();
  const brandId = id ? parseInt(id, 10) : 0;
  if (!brandId) return null;
  return <Onboarding brandId={brandId} />;
}
